import React from "react";
import { Card } from "react-bootstrap";
import IconHeader from "./IconHeader";
import IconSubheader from "./IconSubheader";

import "./IconSupportCard.scss";

const IconSupportCard = () => {
  const supportCardContact = (
    formOfContact: string,
    displayText: string,
    href: string,
    analyticsTracker: string
  ) => {
    return (
      <div className="icon-support-card">
        <p className="icon-support-card-text">
          {formOfContact}{" "}
          <a
            className="icon-support-card-link"
            href={href}
            onClick={() => {
              window.analytics.track(analyticsTracker);
            }}
          >
            {displayText}
          </a>
        </p>
      </div>
    );
  };

  return (
    <Card className="icon-support-card-container">
      <Card.Header
        style={{
          padding: 0,
        }}
      >
        <div className="icon-support-card-header">
          <IconHeader
            variant="iconBanner"
            style={{ color: "#1D99A9", marginBottom: 10 }}
            headerText="Questions? We’re here to help:"
          />
        </div>
      </Card.Header>

      {supportCardContact(
        "Phone: ",
        "1 (888) 544-9451",
        "tel:18885449451",
        "Clicked Phone Link on Account Sign up"
      )}
      {supportCardContact(
        "Email: ",
        "Support@IconSavingsPlan.com",
        "mailto:support@iconsavingsplan.com",
        "Clicked Support Link on Account Sign up"
      )}

      <div className="icon-support-card-divider">
        <IconSubheader
          subheader="Icon is an SEC-registered investment advisor."
          style={{ fontSize: 12, marginTop: 10 }}
        />
      </div>
    </Card>
  );
};

export default IconSupportCard;
